import { Notify } from "Component/Notify";
import Spinner from "Component/Spinner";
import { fetchApi } from "Config/fetchApi";
import { handleError } from "Helper";
import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "Mei",
  "Jun",
  "Jul",
  "Agu",
  "Sep",
  "Okt",
  "Nov",
  "Des",
];

const TargetDetected = () => {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [datas, setDatas] = useState({
    dpo: [],
    target: [],
  });
  // console.log(datas, "datas");
  const [isLoading, setIsLoading] = useState(false);

  const getDatas = async (selectedYear) => {
    setIsLoading(true);
    try {
      const response = await fetchApi().get(
        `/dashboard/target-detection?year=${selectedYear}`
      );

      const result = response?.data?.data;

      if (result) {
        setDatas({
          dpo: result.map((item) => item.total_dpo),
          target: result.map((item) => item.orang_dikenali),
        });
      }
    } catch (err) {
      setDatas({ dpo: [], target: [] });
      handleError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getDatas(year);
  }, [year]);

  const handleYearChange = (event) => {
    setYear(parseInt(event.target.value, 10));
  };

  const today = new Date();
  const formatDate = `${today.getDate().toString().padStart(2, "0")}${(
    today.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}${today.getFullYear()}`;

  const filename = `FR_${formatDate}_ChartTargetTerdeteksi`;

  const chartData = {
    series: [
      {
        name: "Orang Terdeteksi",
        data: datas.target,
        color: "#3B82F6",
      },
      {
        name: "DPO",
        data: datas.dpo,
        color: "#EF4444", // biru
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: true,
          tools: {
            download: true,
          },
          export: {
            csv: { filename },
            svg: { filename },
            png: { filename },
          },
        },
      },

      states: {
        normal: {
          filter: {
            type: "none",
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "none",
          },
        },
      },
      plotOptions: {
        bar: { horizontal: false, columnWidth: "55%", endingShape: "rounded" },
      },
      dataLabels: { enabled: false },
      xaxis: {
        categories: MONTHS,
        title: { text: "Bulan" },
      },
      yaxis: { title: { text: "Jumlah" } },
      legend: { position: "bottom" },
      fill: { opacity: 1 },
      tooltip: {
        y: {
          formatter: (val) => `${val} dikenali`,
        },
      },
    },
  };

  return (
    <div className="bg-white w-full border border-gray-300 rounded-xl shadow-md p-4">
      <div className="flex items-center justify-between my-2">
        <h2 className="font-bold">Target Terdeteksi</h2>
        <select
          className="border border-gray-300 rounded px-2 py-1"
          value={year}
          onChange={handleYearChange}
        >
          {[currentYear, currentYear - 1, currentYear - 2].map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>
      {isLoading ? (
        <div className="flex items-center justify-center my-4">
          <Spinner classAddition={"h-14"} />
        </div>
      ) : (
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={350}
        />
      )}
    </div>
  );
};

export default TargetDetected;
